import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Col, Form, Row, Select, Typography } from 'antd';
import { searchSelectProps } from '../../constants';

const { Text } = Typography;

const SelectionFormModal = ({
  selectProps,
  status,
  onSubmit,
  form,
  title,
  isOpen,
  onClose,
  initialValues,
}) => {
  const renderOptions = (data) =>
    data.map((item) => (
      <Select.Option key={item?.id} value={item?.id}>
        {item.name}
      </Select.Option>
    ));

  const renderSelectInput = (data, label, name, mode) => (
    <Form.Item label={label} name={name}>
      <Select {...searchSelectProps} allowClear mode={mode}>
        {renderOptions(data)}
      </Select>
    </Form.Item>
  );

  const renderAllSelectionInputs = () =>
    selectProps.map(({ bids, label, name, mode }) =>
      renderSelectInput(bids, label, name, mode)
    );

  const noBids = selectProps.reduce(
    (prev, current) => prev && current?.bids?.length === 0,
    true
  );

  return (
    <Modal
      title={title}
      onFinish={onSubmit}
      visible={isOpen}
      onCancel={onClose}
      footer={null}
    >
      {noBids && <span>No bids sent!</span>}
      {!noBids && (
        <Form
          form={form}
          labelCol={{ span: 10 }}
          onFinish={onSubmit}
          initialValues={initialValues}
        >
          <section>{renderAllSelectionInputs()}</section>

          {status.type === 'ERROR' && (
            <Text type="danger">{status.message}</Text>
          )}
          <br />

          <Row justify="end" gutter={12}>
            <Col>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

const TrainerPropDataStructure = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

SelectionFormModal.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  status: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.any,
  selectProps: PropTypes.arrayOf(
    PropTypes.shape({
      bids: PropTypes.arrayOf(PropTypes.shape(TrainerPropDataStructure)),
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      mode: PropTypes.string,
    })
  ),
  initialValues: PropTypes.object,
};

export default SelectionFormModal;
